import { render, staticRenderFns } from "./NsAlert.vue?vue&type=template&id=c295f7f6&scoped=true&"
import script from "./NsAlert.vue?vue&type=script&lang=js&"
export * from "./NsAlert.vue?vue&type=script&lang=js&"
import style0 from "./NsAlert.vue?vue&type=style&index=0&id=c295f7f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c295f7f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c295f7f6')) {
      api.createRecord('c295f7f6', component.options)
    } else {
      api.reload('c295f7f6', component.options)
    }
    module.hot.accept("./NsAlert.vue?vue&type=template&id=c295f7f6&scoped=true&", function () {
      api.rerender('c295f7f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/design-components/src/components/NsAlert.vue"
export default component.exports